import {
  Component,
  inject,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MONLOG_DETAILS_CONTAINER,
  CONTACT_DETAIL_CONTAINER,
} from 'src/app/constants/common.constants';
import { TabService } from 'src/app/core/services/tab.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

type FieldVisionMessage = {
  type: 'openLog';
  id: string;
};

@Component({
  selector: 'app-field-vision-embed',
  templateUrl: './field-vision-embed.component.html',
  styleUrls: ['./field-vision-embed.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafeUrlPipe],
})
export class FieldVisionEmbedComponent implements OnInit, OnDestroy {
  protected _env = inject(EnvironmentService);
  protected _tabService = inject(TabService);
  protected _translateService = inject(TranslateService);

  fieldVisionUrl: string;

  constructor() {
    this.fieldVisionUrl = this._env.getFieldVisionUrl();
  }

  async ngOnInit() {
    const label = await firstValueFrom(
      this._translateService.get('MAP.LABEL.FIELD_VISION')
    );
    this._tabService.updateActiveTabLabel(label);
    window.addEventListener(
      'message',
      (e: MessageEvent) => {
        this.handleMessage(e);
      },
      false
    );
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage(event: MessageEvent) {
    if (
      event.origin.replace(/\/+$/, '') !==
      this.fieldVisionUrl.replace(/\/+$/, '')
    ) {
      return;
    }
    const data: FieldVisionMessage = event.data;
    if (data.type === 'openLog') {
      this.openMonLog(data.id);
    } else if (data.type === 'openContact') {
      this.openContact(data.id);
    }
  }

  openMonLog(monLogIdKey: string) {
    const tab = this._tabService.buildNewTab(
      MONLOG_DETAILS_CONTAINER,
      true,
      undefined,
      monLogIdKey
    );
    this._tabService.openTab(tab);
  }

  openContact(contactIdKey: string) {
    const tab = this._tabService.buildNewTab(
      CONTACT_DETAIL_CONTAINER,
      true,
      undefined,
      contactIdKey
    );
    this._tabService.openTab(tab);
  }
}
